
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_72_10084)"}},[_c('path',{attrs:{"d":"M15.21 11.166c.03 3.323 2.915 4.428 2.947 4.442-.025.079-.461 1.576-1.52 3.124-.915 1.337-1.865 2.67-3.361 2.698-1.47.027-1.943-.872-3.624-.872-1.68 0-2.206.844-3.598.899-1.444.054-2.544-1.447-3.467-2.78C.702 15.951-.739 10.974 1.196 7.614c.96-1.668 2.679-2.725 4.543-2.752 1.418-.027 2.757.954 3.624.954s2.493-1.18 4.204-1.006c.716.03 2.725.289 4.016 2.178-.104.064-2.398 1.4-2.373 4.178m-2.764-8.16C13.213 2.078 13.73.786 13.59-.5c-1.106.044-2.442.737-3.235 1.664-.71.822-1.333 2.137-1.165 3.397 1.232.095 2.49-.626 3.258-1.555z","fill":"#151314"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_72_10084"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.06)","d":"M0 0h17.879v22H0z"}})])])])
          )
        }
      }
    